import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import axios from "axios";
import { apiEndpoint } from "../../urls";

export const fetchPdfEditorDetails = createAsyncThunk(
  "pdfEditorToken/fetchPdfEditorDetails",
  async (username, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/get_pdf_editor_details`,
        { username }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Unknown error"
      );
    }
  }
);

export const refreshToken = createAsyncThunk(
  "pdfEditorToken/refreshToken",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const refresh = state.pdfEditortoken.refreshToken;
      console.log(refresh)
      if (!refresh) {
        return rejectWithValue("No refresh token available");
      }

      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/token/refresh/`,
        { refresh }
      );
      return response.data;
    } catch (error) {
      console.log(error)
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const pdfEditorTokenReducer = createSlice({
  name: "pdfEditorToken",
  initialState: {
    pdfEditortoken: {},
    status: STATUSES.IDLE,
    error: null,
    accessToken: null,
    refreshToken: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPdfEditorDetails.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchPdfEditorDetails.fulfilled, (state, action) => {
        state.pdfEditortoken = action.payload;
        state.accessToken = action.payload.access || null;
        state.refreshToken = action.payload.refresh || null;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchPdfEditorDetails.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      })
      .addCase(refreshToken.pending, (state) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.pdfEditortoken = action.payload;
        state.accessToken = action.payload.access || null;        
        state.refreshToken = action.payload.refresh || null;
        state.status = STATUSES.IDLE;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default pdfEditorTokenReducer.reducer;
